import React, { useCallback, useEffect, useRef, useState } from "react";
import GlobalWrapper from "../../components/Wrapper/GlobalWrapper";
import { Box, Card, Chip, Grid, Typography } from "@mui/material";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import AssessmentCourseCard from "./AssessmentCourseCard";
import { useLocation, useNavigate } from "react-router-dom";
import FromAndToDatePicker from "../../components/mui/FromAndToDatePicker";
import dayjs from "dayjs";
import { getAssessmentData } from "../../redux/features/assessmentDashboardSlice";

const AssessmentToolDashboard = () => {
  const userProfile = JSON.parse(localStorage.getItem("cred")).profile;

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const userIDparams = searchParams.get("userID");
  const fromdate = searchParams.get("fromDate");
  const todate = searchParams.get("toDate");

  const [fromDate, setFromDate] = useState(
    fromdate || dayjs().startOf("month").format("YYYY-MM-DD")
  );
  const [toDate, setToDate] = useState(
    todate || dayjs().endOf("month").format("YYYY-MM-DD")
  );

  // const userID =
  //   userProfile.roleID === 30 || userProfile.roleID === 90
  //     ? userProfile.userId
  //     : 249;

  const userID = userProfile.userId;

  const dispatch = useDispatch();
  const fromDateRef = useRef(fromDate); //USING USEREF BECAUSE WHILE USING USECALBACK INORDER TO PROVIDE UN WANTED RE RENDER
  const toDateRef = useRef(toDate);
  const navigate = useNavigate();
  const { assessmentData } = useSelector((state) => state.assessmentDashboard);
  useEffect(() => {
    dispatch(
      getAssessmentData({
        fromDate: fromDate,
        toDate: toDate,
        userID: userID,
        dateFilter: 1,
      })
    );
  }, [fromDate, toDate, userID]);

  useEffect(() => {
    fromDateRef.current = fromDate;
    toDateRef.current = toDate;
  }, [fromDate, toDate]);

  const clickFunction = useCallback(
    (userId, course_name) => {
      const fromDateValue = fromDateRef.current;
      const toDateValue = toDateRef.current;

      if (course_name === "Others") {
        navigate(
          `/my-workspace/grade-wise-report?userID=${userId}&fromDate=${fromDateValue}&toDate=${toDateValue}`
        );
      } else {
        navigate(
          `/my-workspace/assessment-report?userID=${userId}&course_name=${course_name}&fromDate=${fromDateValue}&toDate=${toDateValue}`
        );
      }
    },
    [navigate]
  );

  return (
    <GlobalWrapper title={"Assessment Dashboard"}>
      <Box sx={{ display: "flex", mb: 1 }}>
        <FromAndToDatePicker
          disabled={false}
          fromDate={fromDate}
          toDate={toDate}
          setFromDate={setFromDate}
          setToDate={setToDate}
        />
      </Box>
      <Box>
        <Card
          sx={{
            background:
              "linear-gradient(135deg,rgba(0, 139, 208, 0.79),rgba(160, 37, 194, 0.74))",
            color: "#fff",
            borderRadius: 3,
            width: "100%",
            maxWidth: 350,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: 2,
          }}
        >
          <Chip
            label={`Total Non Enrolled : ${assessmentData.totalnonCourseEnrolledCount}`}
            variant="outlined"
            sx={{
              backgroundColor: "white",
              color: "#a125c2",
              fontWeight: 500,
              fontSize: "1rem",
              padding: 1,
            }}
          ></Chip>
        </Card>
      </Box>
      <Box
        sx={{
          paddingTop: 2,
        }}
      >
        <Grid container spacing={2}>
          {assessmentData.courseData?.map((item, index) => (
            <Grid item xs={12} sm={6} md={4} key={item.course_name}>
              <AssessmentCourseCard
                name={item.course_name ?? "Others"}
                userId={userID}
                course_name={item.course_name ?? "Others"}
                admissionNotTaken={item.nonCourseEnrolledCount}
                color="#7054eb"
                clickFunction={clickFunction}
                delay={index * 0.2}
              />
            </Grid>
          ))}
        </Grid>
      </Box>
    </GlobalWrapper>
  );
};

export default AssessmentToolDashboard;
